import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import { WebsiteFooter } from 'src/editor/shared/entities/website-footer'
import { WebsiteHeader } from 'src/editor/shared/entities/website-header'
import { WebsiteLayoutBody } from 'src/editor/shared/entities/website-layout-body'
import { WebsiteFooterInterface } from 'src/shared/types/website-footer-interface'
import { WebsiteHeaderInterface } from 'src/shared/types/website-header-interface'
import { WebsiteLayoutBodyInterface } from 'src/shared/types/website-layout-body-interface'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'

export const createEntityElement = (
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) => {
  switch (entity.type) {
    case EntityTypeEnum.WebsiteLayoutBody:
      return <WebsiteLayoutBody entity={entity as WebsiteLayoutBodyInterface} />
    case EntityTypeEnum.WebsiteHeader:
      return (
        <WebsiteHeader
          entity={entity as WebsiteHeaderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteHomepageBody:
      return <div>website home body</div>
    case EntityTypeEnum.WebsiteFooter:
      return (
        <WebsiteFooter
          entity={entity as WebsiteFooterInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
